import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#307FE2",
      fillRule: "evenodd",
      d: "M10 9C4.477 9 0 13.477 0 19v10c0 5.523 4.477 10 10 10h28c5.523 0 10-4.477 10-10V19c0-5.523-4.477-10-10-10H10Zm-3.222 9.975V30h4.788c1.937 0 3.607-1.386 3.607-3.213 0-1.291-.74-2.315-1.796-2.614.772-.363 1.323-1.276 1.323-2.174 0-1.622-1.59-3.024-3.606-3.024H6.778Zm4.174 4.221H9.77v-1.355h1.18c.41 0 .741.3.741.678 0 .378-.33.677-.74.677ZM9.77 27.134h1.527a.84.84 0 0 0 .835-.835c0-.457-.362-.835-.803-.835H9.77v1.67Zm13.356-8.159h-7.088V30h7.088v-2.866h-4.095v-1.26h3.654v-2.867h-3.654v-1.166h4.095v-2.866Zm9.686 0v2.866H29.82V30h-2.992v-8.159h-2.993v-2.866h8.978Zm5.527 9.67L38.844 30h3.245L37.71 18.975h-2.362L31 30h3.166l.504-1.355h3.67Zm-2.709-2.551h1.78l-.882-2.378-.898 2.378Z",
      clipRule: "evenodd"
    }
  )
);
var SvgBetaOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BetaOutlined_default = SvgBetaOutlined;

export { BetaOutlined_default as default };
